import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b1d0403"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "contactInfo"
};
const _hoisted_2 = {
  class: "hover-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}), /*#__PURE__*/_createTextVNode(" 微信咨询")], -1));
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "微信扫码添加客服小云", -1));
const _hoisted_6 = {
  class: "popup-box",
  style: {
    "height": "56vh"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_9 = {
  key: 1,
  class: "float-box"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flickers"
}, [/*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}), /*#__PURE__*/_createTextVNode("免费试用")])], -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  class: "tab-box wachate-box"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_14 = {
  class: "hover-box"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}), /*#__PURE__*/_createTextVNode(" 微信咨询")], -1));
const _hoisted_16 = ["src"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "微信扫码添加客服小云", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_boook_demo_page = _resolveComponent("boook-demo-page");
  return _openBlock(), _createElementBlock("div", null, [_ctx.isMobile ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    show: _ctx.showRQcode,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => _ctx.showRQcode = $event),
    "close-on-popstate": true
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("img", {
      class: "WeChat",
      src: require('@/assets/img/customerService.png'),
      alt: "云起无垠"
    }, null, 8, _hoisted_4), _hoisted_5])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: _ctx.showDemoPage,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => _ctx.showDemoPage = $event),
    position: "bottom",
    "close-on-popstate": true
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_boook_demo_page)])]),
    _: 1
  }, 8, ["show"]), _createElementVNode("p", {
    class: "tab-box box",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.clickCode('RQCode'))
  }, [_hoisted_7, _createTextVNode("微信客服 ")]), _createElementVNode("p", {
    class: "tab-box one",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.clickCode('demoPage'))
  }, [_hoisted_8, _createTextVNode("免费试用产品")])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
    class: "tab-box one",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.jumpPage('/bookDemoPage.html'))
  }, _hoisted_11), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createTextVNode("微信客服 "), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("img", {
    class: "WeChat",
    src: require('@/assets/img/customerService.png'),
    alt: "云起无垠"
  }, null, 8, _hoisted_16), _hoisted_17])])]))]);
}